import { lazy } from "react"
import { IRecipeInstance } from "store/apis/recipeAPI"

export const RECIPE_MODALS = {
  recipeDetails: {
    component: lazy(() => import("modals/ui/recipe/RecipeDetailsModal")),
    params: {} as {
      recipeInstance: IRecipeInstance
    }
  }
} as const
